
import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { ProviderSelection } from "./ProviderSelection";
import { ExchangeSelection } from "./ExchangeSelection";
import { LeadAccount, StrategyProvider } from "@/types/strategy-types";

interface LeadAccountFormFieldsProps {
  formData: Omit<LeadAccount, 'id' | 'created_at' | 'updated_at'>;
  handleChange: (field: keyof Omit<LeadAccount, 'id' | 'created_at' | 'updated_at'>, value: any) => void;
  providerId: string | null;
  providers: StrategyProvider[];
  userRole?: string | null;
}

export const LeadAccountFormFields = ({
  formData,
  handleChange,
  providerId,
  providers,
  userRole
}: LeadAccountFormFieldsProps) => {
  return (
    <div className="space-y-4">
      <ProviderSelection
        userRole={userRole}
        providerId={providerId}
        providers={providers}
        value={formData.strategy_provider_id}
        onChange={(value) => handleChange("strategy_provider_id", value)}
      />
      
      <div className="space-y-2">
        <Label htmlFor="external_id">External ID</Label>
        <Input
          id="external_id"
          value={formData.external_id}
          onChange={(e) => handleChange("external_id", e.target.value)}
          required
        />
      </div>
      
      <ExchangeSelection 
        value={formData.exchange}
        onChange={(value) => handleChange("exchange", value)}
      />
      
      <div className="flex items-center space-x-2">
        <Checkbox
          id="active"
          checked={formData.active}
          onCheckedChange={(checked) => handleChange("active", !!checked)}
        />
        <Label htmlFor="active">Active</Label>
      </div>
    </div>
  );
};
